module.exports = __webpack_public_path__ + "img/4.f937fdf2.jpg";